import { Injectable, Injector } from '@angular/core';
import { BaseService, ResponseResult } from 'vnpost-shared';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class JobTitleService extends BaseService {
  constructor(http: HttpClient, injector: Injector) {
    super(http, injector, `${environment.apiDomain.llbJavaEndpoint}/jobTitle`);
  }
  getAllJob(model): Promise<any> {
    const apiUrl = `${this.serviceUri}/getAll?search=${model?.search ?? ''}`;
    return this._http
      .get<any>(apiUrl)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }

  getLevel(model: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/getLevel`;
    return this._http
      .get<any>(apiUrl)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }

  getAll(model: any): Promise<any> {
    const apiUrl =
      `${this.serviceUri}/getAll?levelId=` +
      model.levelId +
      `&unitCode=` +
      model.unitCode;
    return this._http
      .get<any>(apiUrl)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
}
